import React from 'react';
import type { ShopifyOfferDto } from '../../../offer.types';
import type { CheckoutHeaderConfig } from '../../../services/checkoutConfig/checkoutConfig.types';
import SecurePurchaseBadgeIcon from '../../icons/general/SecurePurchaseBadgeIcon';

interface CheckoutHeaderProps {
  shopifyOffer: ShopifyOfferDto;
  config: CheckoutHeaderConfig;
}

export const CheckoutHeader: React.FC<CheckoutHeaderProps> = ({ shopifyOffer, config }) => {
  const handleLogoClick = () => {
    // Redirecionar para a homepage da loja
    // Tenta homePage primeiro, depois corsUrl como fallback
    if (shopifyOffer?.store?.homePage) {
      window.location.href = shopifyOffer.store.homePage;
    } else if (shopifyOffer?.store?.corsUrl) {
      window.location.href = shopifyOffer.store.corsUrl;
    } else {
      console.warn('Homepage ou corsUrl da loja não encontrados');
    }
  };

  const storeName = shopifyOffer?.store?.name || 'Checkout';
  const logoSrc = config.logo;
  const backgroundColor = config.backgroundColor || '#191919';
  const textColor = config.textColor || '#FFFFFF';
  const showSecurityIcon = config.showSecurityIcon !== false;

  return (
    <header
      className="shadow-sm dark:shadow-md p-2"
      style={{ backgroundColor, color: textColor }}
    >
      <div className="container mx-auto flex flex-row justify-between items-center">
        <div
          onClick={handleLogoClick}
          className="cursor-pointer hover:opacity-80 transition-opacity duration-200"
          title="Clique para ir para a loja"
        >
          {logoSrc ? (
            <img
              src={logoSrc}
              alt={storeName}
              loading="eager"
              className="header__heading-logo motion-reduce"
              style={{
                maxHeight: '50px',
                width: 'auto',
                marginRight: '10px',
              }}
            />
          ) : (
            <span className="font-semibold text-lg" style={{ color: textColor }}>
              {storeName}
            </span>
          )}
        </div>
        {showSecurityIcon && (
          <div className="flex items-center space-x-4 text-xs" style={{ color: textColor }}>
            <SecurePurchaseBadgeIcon />
          </div>
        )}
      </div>
    </header>
  );
};
